import { gql } from "graphql-tag";

export const getAssignedServices = gql`
  query GetAssignedServices(
    $serviceType: String!
    $skip: Int
    $first: Int
    $category: String
    $status: String
    $programId: ID
    $searchString: String
  ) {
    assignedExpertServices(
      orderBy: createdAt_DESC
      where: {
        expertService: {
          type: $serviceType 
          category: $category
        }
        status: $status
        batch: {
          program: {
            id: $programId
          }
        }
        OR: [
          {
            expertService: {
              OR: [
                { iname_contains: $searchString },
                { idescription_contains: $searchString },
                { expert: { ifullName_contains: $searchString } }
              ]
            }
          },
          {
            batch: { program: { iname_contains: $searchString } }
          },
          {
            batch: { iname_contains: $searchString }
          },
          {
            ode: { iname_contains: $searchString }
          }
        ]
      }
      skip: $skip
      first: $first
    ) {
      id
      isProbono
      expertServicePrice
      assignedUnits
      availableUnits
      expertServiceData
      assignmentDate
      limitDate
      status
      batch {
        id
        name
        program {
          id
          name
        }
      }
      expertService {
        id
        name
        type
        category
        duration
      }
      ode {
        id
        name
      }
    }
    meta: assignedExpertServicesConnection(
      where: {
        expertService: {
          type: $serviceType 
          category: $category
        }
        status: $status
        batch: {
          program: {
            id: $programId
          }
        }
        OR: [
          {
            expertService: {
              OR: [
                { iname_contains: $searchString },
                { idescription_contains: $searchString },
                { expert: { ifullName_contains: $searchString } }
              ]
            }
          },
          {
            batch: { program: { iname_contains: $searchString } }
          },
          {
            batch: { iname_contains: $searchString }
          },
          {
            ode: { iname_contains: $searchString }
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;
